import detailStyles from '../ChallengeDetail.module.scss';
import image121 from './images/12-1.jpg';
import image141 from './images/14-1.jpg';
import image142 from './images/14-2.jpg';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';

export const WheelOfFortuneDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>«Заработок»</b>
                </div>
                <ChallengeDetailHelpImage image={image121} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Откройте вкладку <b>«Мини-игры»</b>
                </div>
                <ChallengeDetailHelpImage image={image141} helpText='Это картинка. Ищите подраздел в разделе «Заработок».' />
            </p>
            
            <p>
                <div>
                    Выбирите <b>«Колесо фортуны»</b> и нажмите кнопку <b>«Крутить бесплатно»</b>
                </div>
                <ChallengeDetailHelpImage image={image142} helpText='Это картинка. Ищите кнопку в странице игры.' />
            </p>
        </div>
    );
}